import './App.css';
import AboutSection from './component/about-section/about-section';
import HomeSection from './component/home-section/home-section';

function App() {
  return (
    <div className="app">
      <HomeSection/>
      <AboutSection/>
    </div>
  );
}

export default App;
